import { Spin } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

// layout needs to be imported as first component
// otherwise css order breaks
// https://github.com/gatsbyjs/gatsby/issues/9733#issuecomment-490132623
import { useFetchAccountOptions } from '../api/actions/useFetchAccountOptions';
import { useFetchInboxDictionary } from '../api/actions/useFetchInboxDictionary';
import { InboxMassOfferingsContent } from '../components/InboxMassOfferings/InboxMassOfferingsContent/InboxMassOfferingsContent';
import InboxMassOfferingsLayout from '../components/Layout/InboxMassOfferingsLayout';
import selectors from '../store/selectors';

const InboxMassOfferings = () => {
  const isFetchingAccountOptions = useFetchAccountOptions();
  const isInboxMassOfferingsActive = useSelector(selectors.selectIsInboxMassOfferingsActive);
  const massOfferingAmount = useSelector(selectors.selectMassOfferingAmountOption);
  const { payload: inboxDictionary, loading: isFetchingInboxDictionary } =
    useFetchInboxDictionary();

  let content = null;
  if (isFetchingAccountOptions || isFetchingInboxDictionary || massOfferingAmount === undefined) {
    content = <Spin />;
  } else if (isInboxMassOfferingsActive) {
    content = <InboxMassOfferingsContent inboxDictionary={inboxDictionary} />;
  } else {
    // content = <InboxMassOfferingsNotActive />;
    content = (
      <div>
        <p>Nie przyjmujemy obecnie intencji bezterminowych poprzez formularz online.</p>
      </div>
    );
  }

  return <InboxMassOfferingsLayout>{content}</InboxMassOfferingsLayout>;
};

export default InboxMassOfferings;
